import fetchRequest from "../services/fetchRequest";
import appSettings from "../settings/appSettings";
import { wvusLogger } from "../helpers";
import { BraintreeClientParamsConfig } from "../types";

async function requestClientParams() {
  // TODO: Update Core 4 Template To Expose the fusionConfig object to the window object
  const { braintreeClientParamsConfig = {} as BraintreeClientParamsConfig } = appSettings;
  const requestUrl = `${braintreeClientParamsConfig.baseUrl}/BraintreeClientParams`;
  const apiKey = braintreeClientParamsConfig.apiKey;
  const requestOpts = {
    method: "GET",
    timeout: 10 * 1000,
    headers: {
      "x-api-key": apiKey
    }
  };

  try {
    const response = await fetchRequest(requestUrl, requestOpts);
    const respJson = await response.json().then((data) => data);

    if (!respJson?.success || !respJson?.data?.clientToken) {
      const responseError = new Error("Invalid service response.");
      throw { ...responseError, ...requestOpts, url: requestUrl };
    }

    return respJson.data;
  } catch (err) {
    wvusLogger.log(err, wvusLogger.getLogLevelNames().ERROR);
    return Promise.reject(err);
  }
}

export default requestClientParams;
